var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import theme from '../../../theme';
import transactionTypeIcons from './TransactionTypeIcons';
export var transactionTypesMap = {
    adjustment: 'Adjustment',
    authorization: 'Authorization',
    cash_advance: 'Cash Advance',
    credit: 'Credit',
    default: 'Transaction',
    interest: 'Interest',
    late_Fee: 'Late Fee',
    payment: 'Payment',
    purchase: 'Purchase',
    refund: 'Refund',
    fee: 'Fee'
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), theme.colors.denimBlue);
var TransactionIcon = function (_a) {
    var transactionType = _a.transactionType, requireIconText = _a.requireIconText;
    var translatedType = transactionTypesMap[transactionType.toLowerCase()];
    return (_jsxs(Wrapper, { children: [transactionTypeIcons[transactionType], requireIconText ? _jsx("span", { children: translatedType }) : null] }));
};
export default TransactionIcon;
var templateObject_1;
//# sourceMappingURL=index.js.map